<template>
	<div class="stage stage--feedback red" :style="{ 'background-image': backgroundImage }">
		<div class="feedback__background-overlay background-overlay">
			
			<div class="content-container">		

				<div class="header__container header__container-explanation shadow-box">
					<div class="subHeader text-whiteX" style="position: relative">
						{{feedback.subheader}}
					</div>
					<div class="header header-whiteX" style="position: relative">
						{{feedback.header}}
					</div>
					<div class="text text-whiteX" style="position: relative" v-html="feedback.feedbacktext">
					</div>
				</div>
				<div class="centered" v-if="typeof feedback.visual!== 'undefined'">
					<img
							:src="baseUrl + feedback.visual"
							class="visual"
					/>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

	import Lottie from '../../../Lottie.vue';
	import * as animationData from '../../../../assets/tut_tinder.json';
	import { url} from '../../../../const/base';
	import {mapGetters , mapActions} from 'vuex';

	export default {

		components:{
			Lottie,
		},

		beforeMount(){
			this.findCorrectFeedback();
		},

		mounted(){
			setTimeout(()=>{
				this.setNextButtonAction(this.lastRound ? this.toNextStage : this.toNextRound).then(()=>{
					this.showNextButton({"btn":true , "btn-progres":true , "btn-progres-utrecht-whiteLine":true});
				});
			},500);
		},
		data(){
			return {
				selectedFeedbackIndex: -1,
				baseUrl : url,
				animationData : animationData
			}
		},
		methods:{

			findCorrectFeedback(){
				if(this.roundData.questions == null || this.roundData.questions.feedback == null) return;
				let index=0;
				for(let i = 0 ; i < this.roundData.questions.feedback.length ; i++){
					let fb = this.roundData.questions.feedback[i];
					if(+fb.score <= this.score && +fb.score >= +this.roundData.questions.feedback[index].score){
						index = i;
					}
				}
				this.selectedFeedbackIndex = index;
			},

			...mapActions([
				"increaseTransitorScore",
				'setNextButtonAction',
				'toNextStage',
				'toNextRound',
				'showNextButton',
			]),
		},
		computed:{

			feedback(){
				console.log('FEEDBACK:');
				console.log(this.roundData.questions.feedback[this.selectedFeedbackIndex]);
				return this.selectedFeedbackIndex >= 0 ?this.roundData.questions.feedback[this.selectedFeedbackIndex] : {header:"Undefined header",subheader:"Undefined subheader",feedbacktext:"Undefined text",visual:"undefined"};
			},

			score(){
				console.log('SCORE:');
				console.log(this.roundData.score);
				return this.roundData.score;
			},

			...mapGetters([
				'currentBlock',
				'currentStage',
				'currentRound',
				'roundData',
				'lastRound',
			]),

			backgroundImage: function() {

				if(typeof this.roundData.questions.feedback_background === 'undefined'){ 
					return 'none';
				}

		        return 'url('+ this.baseUrl + this.roundData.questions.feedback_background + ')';
		    },
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/feedback/default/Index.vue